/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketplace_Seo_Spain_Faq_A4Inputs */

const es_marketplace_seo_spain_faq_a4 = /** @type {(inputs: Marketplace_Seo_Spain_Faq_A4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veleros, lanchas a motor, neumáticas, catamaranes y embarcaciones sin licencia. También hay experiencias de un día con patrón incluido.`)
};

const gl_marketplace_seo_spain_faq_a4 = /** @type {(inputs: Marketplace_Seo_Spain_Faq_A4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veleiros, lanchas a motor, neumáticas, catamaráns e embarcacións sen licenza. Tamén hai experiencias dun día con patrón incluído.`)
};

const en_marketplace_seo_spain_faq_a4 = /** @type {(inputs: Marketplace_Seo_Spain_Faq_A4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sailboats, motorboats, RIBs, catamarans and licence-free craft. There are also day experiences with skipper included.`)
};

/**
* | output |
* | --- |
* | "Sailboats, motorboats, RIBs, catamarans and licence-free craft. There are also day experiences with skipper included." |
*
* @param {Marketplace_Seo_Spain_Faq_A4Inputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const marketplace_seo_spain_faq_a4 = /** @type {((inputs?: Marketplace_Seo_Spain_Faq_A4Inputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketplace_Seo_Spain_Faq_A4Inputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_marketplace_seo_spain_faq_a4(inputs)
	if (locale === "en") return en_marketplace_seo_spain_faq_a4(inputs)
	return es_marketplace_seo_spain_faq_a4(inputs)
});